module.exports = __webpack_public_path__ + "img/download-apk-md.4c8e767.png";